
import { reduce } from 'vessel/utils'

const isItem = ({ tag }) => tag && tag.endsWith('VsBreadcrumbItem')

export default {
  name: 'VsBreadcrumb',
  inheritAttrs: false,
  props: {
    separator: {
      type: String,
      default: '/'
    }
  },
  vessel: {
    wrapper: {
      $attrs: 'all'
    },
    sep: {
      fontSize: 'xs',
      color: 'grey'
    }
  },
  methods: {
    addSeparators() {
      const cdata = { class: this.$vessels.sep }
      const nodes = this.$createElement('span', cdata, [this.separator])
      const items = this.$slots.default.filter(isItem)

      this.$slots.default = reduce(items, (list, item, index) => {
        if (index) list.push(nodes)
        list.push(item)
      })
    }
  },
  created() {
    this.addSeparators()
  },
  beforeUpdate() {
    this.addSeparators()
  }
}
